import MainContent from '@layout/MainContent/MainContent.component';

function UiKitPage() {
    return <MainContent></MainContent>;
}

export default UiKitPage;
